import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SmsPerformanceDashboard = lazy(() =>
  import("@scenes/AnalyticsDashboard/SmsPerformanceDashboard").then((module) => ({
    default: module.SmsPerformanceDashboard,
  }))
);

export const smsPerformanceNRO: NavigationRoutingObject = {
  Component: SmsPerformanceDashboard,
  componentFeatureFlippers: [],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("email-analytics-dashboard-sidebar-sms-pill-menu-option", "SMS/MMS/RCS Performance"),
  pageNameForTracking: () => "SMS/MMS/RCS Performance",
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission, featureOn }) => {
    // either of these feature flags enables the sms dashboard, if the user has permissions
    const smsDashboardFeaturesEnabled = featureOn("sms_analytics_dashboard") || featureOn("native_sms");
    const userHasViewAppUsagePermission = hasPermission("appGroup", {
      permission: "viewAppUsage",
    });
    const userHasViewReportingPermission = hasPermission("appGroup", {
      permission: "viewReporting",
    });

    // check whether the user has permissions to access the sms dashboard
    const smsDashboardEnabledThroughPermissions =
      smsDashboardFeaturesEnabled && (userHasViewAppUsagePermission || userHasViewReportingPermission);

    return isImpersonating || smsDashboardEnabledThroughPermissions;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("sms-performance-alt-keyword-1", "engagement"),
        t("sms-performance-alt-keyword-2", "sends"),
        t("sms-performance-alt-keyword-3", "confirmed deliveries rate"),
        t("sms-performance-alt-keyword-4", "delivery failure rate"),
        t("sms-performance-alt-keyword-5", "rejections rate"),
        t("sms-performance-alt-keyword-6", "click rate"),
        t("sms-performance-alt-keyword-7", "total opt-ins"),
        t("sms-performance-alt-keyword-8", "total opt-outs"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  noKnockoutFallback: true,
};
